module.exports = __webpack_public_path__ + "static/assets/3275b9dd2a3e78378d43d3cbf0c09e77.svg";